import React from "react";
import { PRICES, CURRENCY } from "./pricing-data";
import { PLAN_CARDS } from "../../intl/pricing";
import { useSelector } from "react-redux";
import classNames from "classnames";

const PlanCards = () => {
  const classCard = classNames(
    "bg-white rounded-2xl text-left p-5 grid grid-cols-1 content-between"
  );

  const { lang, origin, DASHBOARD_URL, SUBSCRIBE_UTM } = useSelector(
    (state) => state.appReducer
  );
  const copy = PLAN_CARDS[lang];
  const prices = PRICES[origin];
  const currency = CURRENCY[origin];

  const plans = [
    {
      id: "buy-reports",
      title: copy.basic.title,
      price: copy.basic.price,
      description: copy.basic.description,
      href: `${DASHBOARD_URL}/store/buy-reports?${SUBSCRIBE_UTM}`,
      cta: copy.basic.cta,
    },
    {
      id: "pro",
      title: copy.professional.title,
      price: `${prices.professional.month}${currency}/${copy.month}`,
      description: copy.professional.description,
      href: `${DASHBOARD_URL}/store/subscribe/checkout/pro/year?${SUBSCRIBE_UTM}`,
      cta: copy.professional.cta,
    },
    {
      id: "proPlus",
      title: copy.professionalPlus.title,
      price: `${prices.professionalPlus.month}${currency}/${copy.month}`,
      description: copy.professionalPlus.description,
      href: `${DASHBOARD_URL}/store/subscribe/checkout/proPlus/year?${SUBSCRIBE_UTM}`,
      cta: copy.professionalPlus.cta,
    },
    {
      id: "enterprise",
      title: copy.enterprise.title,
      price: `${prices.enterprise.month}${currency}/${copy.month}`,
      description: copy.enterprise.description,
      href: `${DASHBOARD_URL}/store/subscribe/checkout/enterprise/year?${SUBSCRIBE_UTM}`,
      cta: copy.enterprise.cta,
    },
  ];

  const classBtn = classNames(
    "px-4 py-2 font-medium  justify-center flex",
    "border  border-transparent ",
    "rounded-xl",
    "text-white",
    "bg-neutral-900 ",
    // "text-black",
    // "hover:text-white",
    "transition ease-in-out"
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 ">
      {plans.map((i, idx) => (
        <div className={classCard} key={`plan-card-${idx}`}>
          <div>
            <div className="text-neutral-900 text-3xl font-medium ">
              {i.title}
            </div>
            <div className="text-neutral-900 text-xl font-medium pt-2 ">
              {i.price}
            </div>
            <div className="text-neutral-600 text-sm leading-[1.5] pt-2">
              {i.description}
            </div>
          </div>
          <div className="pt-5">
            <a className={classBtn} href={i.href}>
              {i.cta}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlanCards;
